define(['basemodel'], (BaseModel) => BaseModel.extend({
    urlRoot: '/roles',

    defaults: {
        id: null,
        name: null,
        roles_list: []
    }
}));
